import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { VaultPreviews } from './VaultPreviews';
import { pillars, volumes, volumeIncludes } from '../data/volumes';
export function Volumes() {
  return <section aria-label="What is inside the ebook" className="bg-transparent" data-id="element-224" data-mp="185q4pzhxajxj">
      <div className="mx-auto max-w-6xl px-5 py-12" style={{
      paddingTop: '19px',
      paddingBottom: "21px"
    }} data-id="element-225" data-mp="1c6a1h1yl3lj5">
        <div className="text-center" data-id="element-226" data-mp="1zvktnv1vc7lo">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-grape" data-id="element-227" data-mp="24u5v1xsuwxbp">
            🏥 THE MENORESET SYSTEM™ — BY SIGMA SMART™
          </p>
          <h2 className="mt-3 font-display text-3xl font-black text-plum sm:text-4xl" data-id="element-228" data-mp="1qtlaaw3dsrfk">
            What Will You Find Inside?
          </h2>
          <p className="mt-2 text-base text-plum/60" data-id="element-229" data-mp="1vvaqsr9dhxb1">
            6 complete volumes · 60+ premium pages — Everything you need in one place.
          </p>
          <div className="mt-6 flex flex-wrap justify-center gap-2" data-id="element-230" data-mp="kf2isab69trz">
            {pillars.map(p => <span key={p} className="rounded-full border border-grape/25 bg-lilac-soft px-3 py-1 text-xs font-bold uppercase tracking-wide text-plum-soft" style={{
            paddingTop: "17px",
            paddingBottom: "19px",
            width: "155px",
            height: "63px"
          }} data-id="element-231" data-mp="3o97z0l13amsf">
                {p}
              </span>)}
          </div>
          <p className="mt-8 font-display text-lg font-black uppercase tracking-[0.18em] text-plum-soft" data-id="element-232" data-mp="3t685uy5rjtkl">
            📚 The 6-Volume Method
          </p>
        </div>

        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-233" data-mp="62tm8pek4ivm">
          {volumes.map((t, i) => <motion.article key={t.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.4,
          delay: i % 3 * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="group rounded-2xl border border-grape/15 bg-white p-5 transition-colors duration-200 ease-out hover:border-grape/45" style={{
          paddingTop: "10px",
          paddingBottom: "8px"
        }} data-id="element-234" data-mp="krg9reec8gxx" data-mpi={i}>
              <div className="flex items-center gap-3" data-id="element-235" data-mp="11stzdu9zi0v3">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-lilac-soft font-display text-lg font-black text-grape" data-id="element-236" data-mp="11tc299r5jdbz">
                  {String(t.n).padStart(2, '0')}
                </span>
                <h3 className="text-sm font-bold leading-tight text-plum" data-id="element-237" data-mp="1bkghmakqp07c">
                  <span aria-hidden="true" data-id="element-238" data-mp="1fjp8n7oeajz7">{t.emoji} </span>
                  {t.title}
                </h3>
              </div>
              <p className="mt-3 text-sm leading-relaxed text-plum/65" data-id="element-239" data-mp="1kl4ydd1ipenx">{t.desc}</p>
            </motion.article>)}
        </div>

        <VaultPreviews data-id="element-240" data-mp="1ui179jvbw2t0" />

        <div className="mt-10 rounded-2xl border border-grape/25 bg-white p-6" data-id="element-241" data-mp="1ugg9lldpw3qx">
          <p className="text-center font-display text-lg font-black text-grape" data-id="element-242" data-mp="3raji2atvozpn">
            ✅ Every volume includes
          </p>
          <ul className="mt-5 grid gap-3 sm:grid-cols-2 lg:grid-cols-4" data-id="element-243" data-mp="409717lrjtz">
            {volumeIncludes.map(item => <li key={item} className="flex items-start gap-2 text-sm text-plum/75" data-id="element-244" data-mp="2dfb2eao98jao">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-grape" strokeWidth={3} data-id="element-245" data-mp="28m88g1fkf7ty" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}